<template>
  <li class="flex-none snap-center p-1 sm:p-1.5 carousel-item">
    <slot></slot>
  </li>
</template>
